import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

export const OrganizationIcon = (props: SVGProps): JSX.Element => {
  const { title = 'Organization', className, ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      className={cn('fill-current', className)}
      {...restProps}
    >
      <title>{title}</title>
      <path d="M6.33333 2.66667H3V4H6.33333V2.66667Z" />
      <path d="M6.33333 5.33334H3V6.66667H6.33333V5.33334Z" />
      <path d="M6.33333 8H3V9.33334H6.33333V8Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.79669 0.0203814C6.54698 -2.06046e-05 6.24381 -1.08155e-05 5.89239 5.32574e-07H3.44097C3.08955 -1.08155e-05 2.78636 -2.06046e-05 2.53665 0.0203814C2.27308 0.0419154 2.01094 0.0894593 1.75869 0.217989C1.38236 0.409735 1.0764 0.715696 0.884654 1.09202C0.756124 1.34427 0.70858 1.60642 0.687046 1.86998C0.666644 2.1197 0.666654 2.42287 0.666667 2.77431V12H0V13.3333H14.6667V12H14V8.10762C14 7.7562 14 7.45303 13.9796 7.20332C13.9581 6.93975 13.9105 6.67761 13.782 6.42535C13.5903 6.04903 13.2843 5.74307 12.908 5.55132C12.6557 5.42279 12.3936 5.37525 12.13 5.35371C11.8803 5.33331 11.5771 5.33332 11.2257 5.33333L8.66667 5.33334V2.77432C8.66668 2.42289 8.66669 2.1197 8.64629 1.86998C8.62475 1.60642 8.57721 1.34427 8.44868 1.09202C8.25693 0.715697 7.95097 0.409736 7.57465 0.217989C7.32239 0.0894593 7.06025 0.0419154 6.79669 0.0203814ZM7.31738 1.97856C7.33282 2.16745 7.33333 2.41563 7.33333 2.8V12H2V2.8C2 2.41563 2.00052 2.16745 2.01595 1.97856C2.03075 1.79745 2.05587 1.7303 2.07266 1.69734C2.13658 1.5719 2.23857 1.46991 2.36401 1.406C2.39697 1.3892 2.46412 1.36408 2.64522 1.34929C2.83412 1.33385 3.0823 1.33334 3.46667 1.33334H5.86667C6.25104 1.33334 6.49922 1.33385 6.68811 1.34929C6.86922 1.36408 6.93637 1.3892 6.96933 1.406C7.09477 1.46991 7.19676 1.5719 7.26067 1.69734C7.27747 1.7303 7.30258 1.79745 7.31738 1.97856ZM12.6507 7.31189C12.6661 7.50078 12.6667 7.74897 12.6667 8.13334V12H8.66667V6.66667H11.2C11.5844 6.66667 11.8326 6.66719 12.0214 6.68262C12.2026 6.69742 12.2697 6.72254 12.3027 6.73933C12.4281 6.80325 12.5301 6.90523 12.594 7.03068C12.6108 7.06364 12.6359 7.13078 12.6507 7.31189Z"
      />
    </svg>
  );
};
